import { API_SERVER } from "../../EnvConfig/env_config";
import { post } from "./service";


export const getCommonData = (payload, onDone) => {
    post(`${API_SERVER}/api/AutoComplete/AutoComplete`, payload, (res) => {
        onDone(res);
    });
};

export const getSearchingColumn = (payload, onDone) => {
    post(`${API_SERVER}api/AutoComplete/GetSearchingColumn`, payload, (res) => {
        onDone(res);
    });
};

export const getMasterData = (payload, onDone) => {
    post(`${API_SERVER}api/AutoComplete/GetMasterData`, payload, (res) => {
        onDone(res);
    });
};
export function ConvertToBlobPDF(value) {
    const binStr = atob(value);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }
    let pdfBlob = new Blob([arr], { type: 'application/pdf' });
    const url = URL.createObjectURL(pdfBlob);
    return url;
}